import { isApp } from './isApp';
import { isServer } from './isServer';

export const getNativeAppVersion = (): string | null => {
  if (isServer() || !isApp()) {
    return null;
  }
  return /(ZepApp\/)([0-9.]+)$/.exec(navigator.userAgent)?.[2] ?? null;
};
